import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Lead } from '@wdx/clmi/clmi-swagger-gen';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class LeadsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getLead(leadId: string): Observable<Lead> {
        return this.http.get<Lead>(
            `${this.config.getConfiguration().API_BASE}/lead/${leadId}`,
        );
    }

    getFavourites(): Observable<Lead[]> {
        return this.http.get<Lead[]>(
            `${this.config.getConfiguration().API_BASE}/lead/favourite`,
        );
    }
}
